
import { useEffect, useState } from 'react';
import { Col, Dropdown, Form, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Language } from '../../types/Language';

interface LanguageSwitcherProps {
  currentLanguage: Language;
  onLanguageChange: (language: Language) => void;
}

const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({ currentLanguage, onLanguageChange }) => {
  const { t } = useTranslation();

  const languages = [
    { key: 'en', name: 'English' },
    { key: 'he', name: 'עברית' }
  ];

  // useEffect(() => {
  //   document.documentElement.lang = i18n.language;
  //   document.documentElement.dir = i18n.language === 'he' ? 'rtl' : 'ltr';
  // }, [i18n.language]);

  return (
    <div className="bg-dark text-light rounded">
      <h5 className="mb-3">{t('language')}</h5>
      <Row className="mb-4">
        <Col>
          <div className="d-flex">
            <Form.Group className="d-flex align-items-center">
              <Dropdown>
                <Dropdown.Toggle variant="outline-secondary" className="dropdown-custom">
                  {currentLanguage.name}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {languages.map((lang) => (
                    <Dropdown.Item key={lang.key} onClick={() => onLanguageChange(lang)}>
                      {lang.name}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </Form.Group>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default LanguageSwitcher;